setTimeout(() => {
  const elementToMove = document.querySelector(".size-chart-button");
  const insertAfterElement = document.querySelector(
    ".tee-option--size .tee-option__title"
  );
  if (elementToMove && insertAfterElement) {
    insertAfterElement.appendChild(elementToMove);
  }
}, 3000);
// setInterval(() => {
//   const links = document.querySelectorAll(".text-sm.text-subdued span a");
//   links.forEach((link) => {
//     if (link.href.includes("https://cdn.teeinblue.com/")) {
//       link.textContent = "Dein Foto-Upload";
// }
//   });
//}, 2000);

// document.addEventListener('teeinblue-event-after-cart-added', () => {
//     const drawer = document.querySelector('cart-drawer');
//     if (drawer) {
//         fetch(window.location.pathname + "?sections=cart-drawer,cart-icon-bubble")
//         .then(res => res.json())
//         .then(res => drawer.renderContents({sections: res}));
//         if (drawer.classList.contains('is-empty')) drawer.classList.remove('is-empty');
//     }
// });
